import { Form, Input, Tooltip } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import _ from 'lodash'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DraggableModal } from '../../../../../components/DraggableModal'
import { EntDirectoryInfoName } from '../../../../../models/directoryInfoName'

enum FormField {
	nameKy,
	nameRu,
}

interface IProps {
	show: boolean
	veterinaryProductCategory: EntDirectoryInfoName
	onHide: () => void
	onSubmit: (pos: EntDirectoryInfoName) => Promise<boolean>
}

export const AddVeterinaryProductCategoryModal = (props: IProps) => {
	const { t } = useTranslation()
	const [form] = useForm()
	const [loading, setLoading] = useState<boolean>(false)

	useEffect(() => {
		if (props.show) setFieldsFromEntity()
	}, [props.show])

	const setFieldsFromEntity = (): void => {
		form.setFields([
			{ name: FormField.nameKy, value: props.veterinaryProductCategory.nameKy },
			{ name: FormField.nameRu, value: props.veterinaryProductCategory.nameRu },
		])
	}

	const setEntityFromFields = (): EntDirectoryInfoName => {
		let veterinaryProductCategory = _.cloneDeep(props.veterinaryProductCategory)
		veterinaryProductCategory.nameKy = form.getFieldValue(FormField.nameKy)
		veterinaryProductCategory.nameRu = form.getFieldValue(FormField.nameRu)
		return veterinaryProductCategory
	}

	const handleSubmit = async () => {
		setLoading(true)
		try {
			await form.validateFields()
			const data = setEntityFromFields()
			const result = await props.onSubmit(data)

			if (result) props.onHide()
		} finally {
			setLoading(false)
		}
	}

	return (
		<>
			<DraggableModal
				title={
					props.veterinaryProductCategory.id === 0
						? t('handbooks.types_of_products.Add Product Type')
						: t('handbooks.types_of_products.Edit Product Type')
				}
				visible={props.show}
				onCancel={props.onHide}
				onSubmit={handleSubmit}
				submitLoading={loading}
			>
				<Form initialValues={{ remember: true }} autoComplete='off' layout='vertical' form={form}>
					<Form.Item
						label={t('general.nameKy')}
						name={FormField.nameKy}
						rules={[{ required: true, message: t('msg.fill_in_the_field') }]}
					>
						<Input autoComplete='off' />
					</Form.Item>
					<Form.Item
						label={t('general.nameRu')}
						name={FormField.nameRu}
						rules={[{ required: true, message: t('msg.fill_in_the_field') }]}
					>
						<Input autoComplete='off' />
					</Form.Item>
				</Form>
			</DraggableModal>
		</>
	)
}
